// TranslateWith.Wiki - A web app to translate terms using Wikipedia
// language links

// Copyright (C) 2022 Marien Raat - mail@marienraat.nl

// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as
// published by the Free Software Foundation, either version 3 of the
// License, or (at your option) any later version.

// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.

// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
import Language from './Language';

export const top50Languages : Language[] = [
  {
    "label": "English",
    "value": "en"
  },
  {
    "label": "Cebuano",
    "value": "ceb"
  },
  {
    "label": "Swedish",
    "value": "sv"
  },
  {
    "label": "German",
    "value": "de"
  },
  {
    "label": "French",
    "value": "fr"
  },
  {
    "label": "Dutch",
    "value": "nl"
  },
  {
    "label": "Russian",
    "value": "ru"
  },
  {
    "label": "Italian",
    "value": "it"
  },
  {
    "label": "Spanish",
    "value": "es"
  },
  {
    "label": "Polish",
    "value": "pl"
  },
  {
    "label": "Egyptian Arabic",
    "value": "arz"
  },
  {
    "label": "Japanese",
    "value": "ja"
  },
  {
    "label": "Vietnamese",
    "value": "vi"
  },
  {
    "label": "Waray-Waray",
    "value": "war"
  },
  {
    "label": "Chinese",
    "value": "zh"
  },
  {
    "label": "Arabic",
    "value": "ar"
  },
  {
    "label": "Ukrainian",
    "value": "uk"
  },
  {
    "label": "Portuguese",
    "value": "pt"
  },
  {
    "label": "Persian",
    "value": "fa"
  },
  {
    "label": "Catalan",
    "value": "ca"
  },
  {
    "label": "Serbian",
    "value": "sr"
  },
  {
    "label": "Indonesian",
    "value": "id"
  },
  {
    "label": "Norwegian (Bokmål)",
    "value": "no"
  },
  {
    "label": "Korean",
    "value": "ko"
  },
  {
    "label": "Finnish",
    "value": "fi"
  },
  {
    "label": "Hungarian",
    "value": "hu"
  },
  {
    "label": "Czech",
    "value": "cs"
  },
  {
    "label": "Serbo-Croatian",
    "value": "sh"
  },
  {
    "label": "Min Nan",
    "value": "zh-min-nan"
  },
  {
    "label": "Turkish",
    "value": "tr"
  },
  {
    "label": "Romanian",
    "value": "ro"
  },
  {
    "label": "Chechen",
    "value": "ce"
  },
  {
    "label": "Basque",
    "value": "eu"
  },
  {
    "label": "Malay",
    "value": "ms"
  },
  {
    "label": "Tatar",
    "value": "tt"
  },
  {
    "label": "Esperanto",
    "value": "eo"
  },
  {
    "label": "Hebrew",
    "value": "he"
  },
  {
    "label": "Armenian",
    "value": "hy"
  },
  {
    "label": "Bulgarian",
    "value": "bg"
  },
  {
    "label": "Danish",
    "value": "da"
  },
  {
    "label": "South Azerbaijani",
    "value": "azb"
  },
  {
    "label": "Slovak",
    "value": "sk"
  },
  {
    "label": "Kazakh",
    "value": "kk"
  },
  {
    "label": "Minangkabau",
    "value": "min"
  },
  {
    "label": "Estonian",
    "value": "et"
  },
  {
    "label": "Croatian",
    "value": "hr"
  },
  {
    "label": "Belarusian",
    "value": "be"
  },
  {
    "label": "Lithuanian",
    "value": "lt"
  },
  {
    "label": "Greek",
    "value": "el"
  }
];

export const languages : Language[] = [
  {
    "label": "English",
    "value": "en"
  },
  {
    "label": "Cebuano",
    "value": "ceb"
  },
  {
    "label": "Swedish",
    "value": "sv"
  },
  {
    "label": "German",
    "value": "de"
  },
  {
    "label": "French",
    "value": "fr"
  },
  {
    "label": "Dutch",
    "value": "nl"
  },
  {
    "label": "Russian",
    "value": "ru"
  },
  {
    "label": "Italian",
    "value": "it"
  },
  {
    "label": "Spanish",
    "value": "es"
  },
  {
    "label": "Polish",
    "value": "pl"
  },
  {
    "label": "Egyptian Arabic",
    "value": "arz"
  },
  {
    "label": "Japanese",
    "value": "ja"
  },
  {
    "label": "Vietnamese",
    "value": "vi"
  },
  {
    "label": "Waray-Waray",
    "value": "war"
  },
  {
    "label": "Chinese",
    "value": "zh"
  },
  {
    "label": "Arabic",
    "value": "ar"
  },
  {
    "label": "Ukrainian",
    "value": "uk"
  },
  {
    "label": "Portuguese",
    "value": "pt"
  },
  {
    "label": "Persian",
    "value": "fa"
  },
  {
    "label": "Catalan",
    "value": "ca"
  },
  {
    "label": "Serbian",
    "value": "sr"
  },
  {
    "label": "Indonesian",
    "value": "id"
  },
  {
    "label": "Norwegian (Bokmål)",
    "value": "no"
  },
  {
    "label": "Korean",
    "value": "ko"
  },
  {
    "label": "Finnish",
    "value": "fi"
  },
  {
    "label": "Hungarian",
    "value": "hu"
  },
  {
    "label": "Czech",
    "value": "cs"
  },
  {
    "label": "Serbo-Croatian",
    "value": "sh"
  },
  {
    "label": "Min Nan",
    "value": "zh-min-nan"
  },
  {
    "label": "Turkish",
    "value": "tr"
  },
  {
    "label": "Romanian",
    "value": "ro"
  },
  {
    "label": "Chechen",
    "value": "ce"
  },
  {
    "label": "Basque",
    "value": "eu"
  },
  {
    "label": "Malay",
    "value": "ms"
  },
  {
    "label": "Tatar",
    "value": "tt"
  },
  {
    "label": "Esperanto",
    "value": "eo"
  },
  {
    "label": "Hebrew",
    "value": "he"
  },
  {
    "label": "Armenian",
    "value": "hy"
  },
  {
    "label": "Bulgarian",
    "value": "bg"
  },
  {
    "label": "Danish",
    "value": "da"
  },
  {
    "label": "South Azerbaijani",
    "value": "azb"
  },
  {
    "label": "Slovak",
    "value": "sk"
  },
  {
    "label": "Kazakh",
    "value": "kk"
  },
  {
    "label": "Minangkabau",
    "value": "min"
  },
  {
    "label": "Estonian",
    "value": "et"
  },
  {
    "label": "Croatian",
    "value": "hr"
  },
  {
    "label": "Belarusian",
    "value": "be"
  },
  {
    "label": "Lithuanian",
    "value": "lt"
  },
  {
    "label": "Greek",
    "value": "el"
  },
  {
    "label": "Simple English",
    "value": "simple"
  },
  {
    "label": "Azerbaijani",
    "value": "az"
  },
  {
    "label": "Galician",
    "value": "gl"
  },
  {
    "label": "Slovenian",
    "value": "sl"
  },
  {
    "label": "Urdu",
    "value": "ur"
  },
  {
    "label": "Norwegian (Nynorsk)",
    "value": "nn"
  },
  {
    "label": "Georgian",
    "value": "ka"
  },
  {
    "label": "Hindi",
    "value": "hi"
  },
  {
    "label": "Uzbek",
    "value": "uz"
  },
  {
    "label": "Tamil",
    "value": "ta"
  },
  {
    "label": "Thai",
    "value": "th"
  },
  {
    "label": "Latin",
    "value": "la"
  },
  {
    "label": "Welsh",
    "value": "cy"
  },
  {
    "label": "Asturian",
    "value": "ast"
  },
  {
    "label": "Volapük",
    "value": "vo"
  },
  {
    "label": "Cantonese",
    "value": "zh-yue"
  },
  {
    "label": "Macedonian",
    "value": "mk"
  },
  {
    "label": "Bengali",
    "value": "bn"
  },
  {
    "label": "Latvian",
    "value": "lv"
  },
  {
    "label": "Tajik",
    "value": "tg"
  },
  {
    "label": "Burmese",
    "value": "my"
  },
  {
    "label": "Afrikaans",
    "value": "af"
  },
  {
    "label": "Malagasy",
    "value": "mg"
  },
  {
    "label": "Bosnian",
    "value": "bs"
  },
  {
    "label": "Occitan",
    "value": "oc"
  },
  {
    "label": "Albanian",
    "value": "sq"
  },
  {
    "label": "Low Saxon",
    "value": "nds"
  },
  {
    "label": "Kirghiz",
    "value": "ky"
  },
  {
    "label": "Marathi",
    "value": "mr"
  },
  {
    "label": "Belarusian (Taraškievica)",
    "value": "be-tarask"
  },
  {
    "label": "Malayalam",
    "value": "ml"
  },
  {
    "label": "Telugu",
    "value": "te"
  },
  {
    "label": "Newar",
    "value": "new"
  },
  {
    "label": "Breton",
    "value": "br"
  },
  {
    "label": "Venetian",
    "value": "vec"
  },
  {
    "label": "Swahili",
    "value": "sw"
  },
  {
    "label": "Piedmontese",
    "value": "pms"
  },
  {
    "label": "Javanese",
    "value": "jv"
  },
  {
    "label": "Western Punjabi",
    "value": "pnb"
  },
  {
    "label": "Haitian",
    "value": "ht"
  },
  {
    "label": "Sundanese",
    "value": "su"
  },
  {
    "label": "Luxembourgish",
    "value": "lb"
  },
  {
    "label": "Bashkir",
    "value": "ba"
  },
  {
    "label": "Irish",
    "value": "ga"
  },
  {
    "label": "Silesian",
    "value": "szl"
  },
  {
    "label": "Icelandic",
    "value": "is"
  },
  {
    "label": "Kurdish",
    "value": "ku"
  },
  {
    "label": "Lombard",
    "value": "lmo"
  },
  {
    "label": "Chuvash",
    "value": "cv"
  },
  {
    "label": "West Frisian",
    "value": "fy"
  },
  {
    "label": "Tagalog",
    "value": "tl"
  },
  {
    "label": "Wu",
    "value": "wuu"
  },
  {
    "label": "Scots",
    "value": "sco"
  },
  {
    "label": "Aragonese",
    "value": "an"
  },
  {
    "label": "Zazaki",
    "value": "diq"
  },
  {
    "label": "Punjabi",
    "value": "pa"
  },
  {
    "label": "Sorani",
    "value": "ckb"
  },
  {
    "label": "Yoruba",
    "value": "yo"
  },
  {
    "label": "Nepali",
    "value": "ne"
  },
  {
    "label": "Bavarian",
    "value": "bar"
  },
  {
    "label": "Ido",
    "value": "io"
  },
  {
    "label": "Gujarati",
    "value": "gu"
  },
  {
    "label": "Alemannic",
    "value": "als"
  },
  {
    "label": "Kannada",
    "value": "kn"
  },
  {
    "label": "Sicilian",
    "value": "scn"
  },
  {
    "label": "Bishnupriya Manipuri",
    "value": "bpy"
  },
  {
    "label": "Interlingua",
    "value": "ia"
  },
  {
    "label": "Quechua",
    "value": "qu"
  },
  {
    "label": "Mongolian",
    "value": "mn"
  },
  {
    "label": "Sinhalese",
    "value": "si"
  },
  {
    "label": "Samogitian",
    "value": "bat-smg"
  },
  {
    "label": "Navajo",
    "value": "nv"
  },
  {
    "label": "Mingrelian",
    "value": "xmf"
  },
  {
    "label": "Kotava",
    "value": "avk"
  },
  {
    "label": "Oriya",
    "value": "or"
  },
  {
    "label": "Scottish Gaelic",
    "value": "gd"
  },
  {
    "label": "Min Dong",
    "value": "cdo"
  },
  {
    "label": "Ilokano",
    "value": "ilo"
  },
  {
    "label": "Yiddish",
    "value": "yi"
  },
  {
    "label": "Amharic",
    "value": "am"
  },
  {
    "label": "Neapolitan",
    "value": "nap"
  },
  {
    "label": "Sindhi",
    "value": "sd"
  },
  {
    "label": "Buginese",
    "value": "bug"
  },
  {
    "label": "North Frisian",
    "value": "frr"
  },
  {
    "label": "Ossetian",
    "value": "os"
  },
  {
    "label": "Upper Sorbian",
    "value": "hsb"
  },
  {
    "label": "Maithili",
    "value": "mai"
  },
  {
    "label": "Banyumasan",
    "value": "map-bms"
  },
  {
    "label": "Faroese",
    "value": "fo"
  },
  {
    "label": "Limburgish",
    "value": "li"
  },
  {
    "label": "Sakha",
    "value": "sah"
  },
  {
    "label": "Mazandarani",
    "value": "mzn"
  },
  {
    "label": "Emilian-Romagnol",
    "value": "eml"
  },
  {
    "label": "Acehnese",
    "value": "ace"
  },
  {
    "label": "Pashto",
    "value": "ps"
  },
  {
    "label": "Gorontalo",
    "value": "gor"
  },
  {
    "label": "Hausa",
    "value": "ha"
  },
  {
    "label": "Sanskrit",
    "value": "sa"
  },
  {
    "label": "Central Bicolano",
    "value": "bcl"
  },
  {
    "label": "Crimean Tatar",
    "value": "crh"
  },
  {
    "label": "Walloon",
    "value": "wa"
  },
  {
    "label": "Classical Chinese",
    "value": "zh-classical"
  },
  {
    "label": "Ligurian",
    "value": "lij"
  },
  {
    "label": "Hill Mari",
    "value": "mrj"
  },
  {
    "label": "Meadow Mari",
    "value": "mhr"
  },
  {
    "label": "Fiji Hindi",
    "value": "hif"
  },
  {
    "label": "Zulu",
    "value": "zu"
  },
  {
    "label": "Shan",
    "value": "shn"
  },
  {
    "label": "Hakka",
    "value": "hak"
  },
  {
    "label": "Balinese",
    "value": "ban"
  },
  {
    "label": "Tarantino",
    "value": "roa-tara"
  },
  {
    "label": "Assamese",
    "value": "as"
  },
  {
    "label": "Western Armenian",
    "value": "hyw"
  },
  {
    "label": "Kapampangan",
    "value": "pam"
  },
  {
    "label": "Northern Sotho",
    "value": "nso"
  },
  {
    "label": "Interlingue",
    "value": "ie"
  },
  {
    "label": "Khmer",
    "value": "km"
  },
  {
    "label": "Rusyn",
    "value": "rue"
  },
  {
    "label": "Northern Sami",
    "value": "se"
  },
  {
    "label": "Bhojpuri",
    "value": "bh"
  },
  {
    "label": "West Flemish",
    "value": "vls"
  },
  {
    "label": "Shona",
    "value": "sn"
  },
  {
    "label": "Dutch Low Saxon",
    "value": "nds-nl"
  },
  {
    "label": "Maori",
    "value": "mi"
  },
  {
    "label": "Sardinian",
    "value": "sc"
  },
  {
    "label": "Nahuatl",
    "value": "nah"
  },
  {
    "label": "Vepsian",
    "value": "vep"
  },
  {
    "label": "Erzya",
    "value": "myv"
  },
  {
    "label": "Gan",
    "value": "gan"
  },
  {
    "label": "Santali",
    "value": "sat"
  },
  {
    "label": "Somali",
    "value": "so"
  },
  {
    "label": "Gilaki",
    "value": "glk"
  },
  {
    "label": "Kabyle",
    "value": "kab"
  },
  {
    "label": "Turkmen",
    "value": "tk"
  },
  {
    "label": "Corsican",
    "value": "co"
  },
  {
    "label": "Tibetan",
    "value": "bo"
  },
  {
    "label": "Võro",
    "value": "fiu-vro"
  },
  {
    "label": "Abkhazian",
    "value": "ab"
  },
  {
    "label": "Komi",
    "value": "kv"
  },
  {
    "label": "Kashubian",
    "value": "csb"
  },
  {
    "label": "Picard",
    "value": "pcd"
  },
  {
    "label": "Franco-Provençal",
    "value": "frp"
  },
  {
    "label": "Udmurt",
    "value": "udm"
  },
  {
    "label": "Uyghur",
    "value": "ug"
  },
  {
    "label": "Manx",
    "value": "gv"
  },
  {
    "label": "Meitei",
    "value": "mni"
  },
  {
    "label": "Aymara",
    "value": "ay"
  },
  {
    "label": "Zeelandic",
    "value": "zea"
  },
  {
    "label": "Cornish",
    "value": "kw"
  },
  {
    "label": "Norman",
    "value": "nrm"
  },
  {
    "label": "Moroccan Arabic",
    "value": "ary"
  },
  {
    "label": "Guarani",
    "value": "gn"
  },
  {
    "label": "Maltese",
    "value": "mt"
  },
  {
    "label": "Lezgian",
    "value": "lez"
  },
  {
    "label": "Lingua Franca Nova",
    "value": "lfn"
  },
  {
    "label": "Saterland Frisian",
    "value": "stq"
  },
  {
    "label": "Banjar",
    "value": "bjn"
  },
  {
    "label": "Mirandese",
    "value": "mwl"
  },
  {
    "label": "Lao",
    "value": "lo"
  },
  {
    "label": "Romansh",
    "value": "rm"
  },
  {
    "label": "Saraiki",
    "value": "skr"
  },
  {
    "label": "Livvi-Karelian",
    "value": "olo"
  },
  {
    "label": "Ladino",
    "value": "lad"
  },
  {
    "label": "Goan Konkani",
    "value": "gom"
  },
  {
    "label": "Inari Sami",
    "value": "smn"
  },
  {
    "label": "Friulian",
    "value": "fur"
  },
  {
    "label": "Komi-Permyak",
    "value": "koi"
  },
  {
    "label": "Anglo-Saxon",
    "value": "ang"
  },
  {
    "label": "Lower Sorbian",
    "value": "dsb"
  },
  {
    "label": "Doteli",
    "value": "dty"
  },
  {
    "label": "Extremaduran",
    "value": "ext"
  },
  {
    "label": "Tuvan",
    "value": "tyv"
  },
  {
    "label": "Lingala",
    "value": "ln"
  },
  {
    "label": "Zamboanga Chavacano",
    "value": "cbk-zam"
  },
  {
    "label": "Divehi",
    "value": "dv"
  },
  {
    "label": "Ripuarian",
    "value": "ksh"
  },
  {
    "label": "Gagauz",
    "value": "gag"
  },
  {
    "label": "Buryat",
    "value": "bxr"
  },
  {
    "label": "Palatinate German",
    "value": "pfl"
  },
  {
    "label": "Pali",
    "value": "pi"
  },
  {
    "label": "Pangasinan",
    "value": "pag"
  },
  {
    "label": "Avar",
    "value": "av"
  },
  {
    "label": "Awadhi",
    "value": "awa"
  },
  {
    "label": "Tayal",
    "value": "tay"
  },
  {
    "label": "Hawaiian",
    "value": "haw"
  },
  {
    "label": "Igbo",
    "value": "ig"
  },
  {
    "label": "Kinyarwanda",
    "value": "rw"
  },
  {
    "label": "Papiamentu",
    "value": "pap"
  },
  {
    "label": "Kalmyk",
    "value": "xal"
  },
  {
    "label": "Karachay-Balkar",
    "value": "krc"
  },
  {
    "label": "Sakizaya",
    "value": "szy"
  },
  {
    "label": "Zhuang",
    "value": "za"
  },
  {
    "label": "Pennsylvania German",
    "value": "pdc"
  },
  {
    "label": "Karakalpak",
    "value": "kaa"
  },
  {
    "label": "Ingush",
    "value": "inh"
  },
  {
    "label": "Aramaic",
    "value": "arc"
  },
  {
    "label": "Tongan",
    "value": "to"
  },
  {
    "label": "Kabiye",
    "value": "kbp"
  },
  {
    "label": "Jamaican Patois",
    "value": "jam"
  },
  {
    "label": "Wolof",
    "value": "wo"
  },
  {
    "label": "Nauruan",
    "value": "na"
  },
  {
    "label": "Tok Pisin",
    "value": "tpi"
  },
  {
    "label": "Kabardian Circassian",
    "value": "kbd"
  },
  {
    "label": "Atikamekw",
    "value": "atj"
  },
  {
    "label": "Novial",
    "value": "nov"
  },
  {
    "label": "Kikuyu",
    "value": "ki"
  },
  {
    "label": "Tulu",
    "value": "tcy"
  },
  {
    "label": "Tetum",
    "value": "tet"
  },
  {
    "label": "Akan",
    "value": "ak"
  },
  {
    "label": "Ladin",
    "value": "lld"
  },
  {
    "label": "Moksha",
    "value": "mdf"
  },
  {
    "label": "Luganda",
    "value": "lg"
  },
  {
    "label": "Lojban",
    "value": "jbo"
  },
  {
    "label": "Bislama",
    "value": "bi"
  },
  {
    "label": "Aromanian",
    "value": "roa-rup"
  },
  {
    "label": "Lak",
    "value": "lbe"
  },
  {
    "label": "Kongo",
    "value": "kg"
  },
  {
    "label": "Tahitian",
    "value": "ty"
  },
  {
    "label": "Xhosa",
    "value": "xh"
  },
  {
    "label": "Fijian",
    "value": "fj"
  },
  {
    "label": "Sranan",
    "value": "srn"
  },
  {
    "label": "Oromo",
    "value": "om"
  },
  {
    "label": "Seediq",
    "value": "trv"
  },
  {
    "label": "Guianan Creole",
    "value": "gcr"
  },
  {
    "label": "Tachelhit",
    "value": "shi"
  },
  {
    "label": "Samoan",
    "value": "sm"
  },
  {
    "label": "Latgalian",
    "value": "ltg"
  },
  {
    "label": "N’Ko",
    "value": "nqo"
  },
  {
    "label": "Nias",
    "value": "nia"
  },
  {
    "label": "Cherokee",
    "value": "chr"
  },
  {
    "label": "Twi",
    "value": "tw"
  },
  {
    "label": "Mon",
    "value": "mnw"
  },
  {
    "label": "Southern Altai",
    "value": "alt"
  },
  {
    "label": "Norfolk",
    "value": "pih"
  },
  {
    "label": "Gothic",
    "value": "got"
  },
  {
    "label": "Sesotho",
    "value": "st"
  },
  {
    "label": "Greenlandic",
    "value": "kl"
  },
  {
    "label": "Madurese",
    "value": "mad"
  },
  {
    "label": "Kashmiri",
    "value": "ks"
  },
  {
    "label": "Old Church Slavonic",
    "value": "cu"
  },
  {
    "label": "Chichewa",
    "value": "ny"
  },
  {
    "label": "Tswana",
    "value": "tn"
  },
  {
    "label": "Bambara",
    "value": "bm"
  },
  {
    "label": "Tsonga",
    "value": "ts"
  },
  {
    "label": "Romani",
    "value": "rmy"
  },
  {
    "label": "Venda",
    "value": "ve"
  },
  {
    "label": "Cheyenne",
    "value": "chy"
  },
  {
    "label": "Kirundi",
    "value": "rn"
  },
  {
    "label": "Tumbuka",
    "value": "tum"
  },
  {
    "label": "Dagbani",
    "value": "dag"
  },
  {
    "label": "Inuktitut",
    "value": "iu"
  },
  {
    "label": "Swati",
    "value": "ss"
  },
  {
    "label": "Chamorro",
    "value": "ch"
  },
  {
    "label": "Pontic",
    "value": "pnt"
  },
  {
    "label": "Adyghe",
    "value": "ady"
  },
  {
    "label": "Inupiak",
    "value": "ik"
  },
  {
    "label": "Ewe",
    "value": "ee"
  },
  {
    "label": "Fula",
    "value": "ff"
  },
  {
    "label": "Dinka",
    "value": "din"
  },
  {
    "label": "Sango",
    "value": "sg"
  },
  {
    "label": "Dzongkha",
    "value": "dz"
  },
  {
    "label": "Tigrinya",
    "value": "ti"
  },
  {
    "label": "Cree",
    "value": "cr"
  }
];
